/**
 * @generated SignedSource<<00f9c74a805fb8e923691f4733d04b04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CloudApiHealthStatusHealthStatusEnum = "GREEN" | "RED" | "UNKNOWN" | "YELLOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DeviceConnectivityHealthTag_device$data = {
  readonly deviceHealthStatus: CloudApiHealthStatusHealthStatusEnum | null;
  readonly id: string;
  readonly isOnline: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"DeviceHealthStatusTag_device">;
  readonly " $fragmentType": "DeviceConnectivityHealthTag_device";
};
export type DeviceConnectivityHealthTag_device$key = {
  readonly " $data"?: DeviceConnectivityHealthTag_device$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeviceConnectivityHealthTag_device">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeviceConnectivityHealthTag_device",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOnline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deviceHealthStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeviceHealthStatusTag_device"
    }
  ],
  "type": "Device",
  "abstractKey": "__isDevice"
};

(node as any).hash = "b5c8b6d43caa91706614b9b1539efbe7";

export default node;
